// ImportNudge -- Home's hero with zero active slips (Home live-slip strip spec §5, Q4).
// Single job: one 44pt card-button that says there is nothing to track and opens the import
// method sheet (App wires onImport to the IMPORT tab's own call). Pure: props in, JSX out.
// No hooks, no color literal. Replaces the "0 · $0 · $0" ticker, which was a false signal.
import { JT } from "./jumbotronTokens";

export default function ImportNudge({ onImport }) {
  return (
    <button type="button" data-testid="import-nudge" aria-label="Import a slip" onClick={onImport} style={{
      display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, width: "100%", minHeight: 44, marginBottom: 16,
      background: JT.bg.card, border: `1px solid ${JT.border.hero}`, borderRadius: JT.radius.tile,
      padding: "14px 16px", cursor: "pointer", fontFamily: "inherit", textAlign: "left",
    }}>
      <div>
        <div style={{ ...JT.display900, fontSize: 20, color: JT.text.primary, lineHeight: 1.1 }}>No active slips</div>
        <div style={{ fontSize: 12, fontWeight: 600, color: JT.text.secondary, marginTop: 4 }}>Import a screenshot to start tracking</div>
      </div>
      <span aria-hidden="true" style={{ fontSize: 18, fontWeight: 800, color: JT.brand.accent }}>→</span>
    </button>
  );
}
